import React, { Component } from "react";
import SlideshowOmaha from "./SlideshowOmaha";
import TouchGestureOmaha from "./TouchGestureOmaha";

class AttractLoopOmaha extends Component {
  render() {
    return (
      <div style={{ width: '100vw', height: '100vh', position: 'absolute' }}>
        <SlideshowOmaha {...this.props} />
        <TouchGestureOmaha
          screen={this.props.screen}
          contentX={20}
          contentY={20}
        />        
      </div>
    );
  }
}

export default AttractLoopOmaha;



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/AttractLoopOmaha.jsx